<div class="jumbotron text-left">
  <div class="container">
    <div class="row">
      <div class="col" style="text-align: left;">
        <!-- <h4>{{ year }}</h4> -->
      </div>
    </div>
    <div class="row g-3 align-items-center">
      <div class="col-auto">
        <label for="monthYear" class="col-form-label">Month</label>
      </div>
      <div class="col-auto">
        <input type="month" id="monthYear" class="form-control" aria-describedby="inputHelpInline" [(ngModel)]="report_date">
      </div>
      <div class="col-auto">
        <span id="inputHelpInline" class="form-text">
          Please select month/year from the box.
        </span>
      </div>
      <div class="col-auto">
        <span id="getReport" class="form-text">
          <button type="button" class="btn btn-success" (click)="getReportSpecific()">Get Report</button>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <br>
        </div>
      </div>
      <div class="row">
        <h3>Month: {{month[+report?.month-1]}} {{report?.year}}</h3>
        <table class="table table-bordered text-left" id="excel-table">
          <thead>
            <tr class="table-secondary">
              <th></th>
              <th>Total</th>
              @for (staff of staffs; track staff) {
                <th>
                  {{staff.name}}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>No of appointments </td>
              <td>{{getTotals('G')}}</td>
              @for (staff of staffs; track staff) {
                <td>{{getByStaff(staff.name, 'G')}}</td>
              }
            </tr>
            <tr>
              <td>No of new patients </td>
              <td>{{report?.new_patients.length}}</td>
              @for (staff of staffs; track staff) {
                <td>{{getByStaff(staff.name, 'A')}}</td>
              }
            </tr>
            <!-- <tr>
            <td>Fees of new patient registration </td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->
          <tr>
            <td>No of Medical report Request </td>
            <td>{{report?.medical_reports.length}}</td>
            @for (staff of staffs; track staff) {
              <td>{{getByStaff(staff.name, 'B')}}</td>
            }
          </tr>
          <tr>
            <td>Fees of medical reports </td>
            <td>{{report?.medical_reports_fees}}</td>
            @for (staff of staffs; track staff) {
              <td>{{getByStaff(staff.name, 'F')}}</td>
            }
          </tr>
          <!-- <tr>
          <td>Items sell </td>
          <td></td>
          <td></td>
          <td></td>
        </tr> -->
        <tr>
          <td [attr.colspan]="staffs.length + 2">
            <h2>Services Income Balance </h2>
          </td>
        </tr>
        @for (s of report?.appointments_this_month_service; track s) {
          <tr>
            <td>
              {{s.service_name}}
            </td>
            <td>
              {{s.services_total_fees}}
            </td>
            @for (staff of staffs; track staff) {
              <td>{{getByStaff(staff.name, 'C', s.service_name)}}</td>
            }
          </tr>
        }
        <tr style="background-color: beige;">
          <td><strong>Total Fees:</strong></td>
          <td><strong>{{total_services_fees | number}} OMR</strong></td>
          <td [attr.colspan]="staffs.length + 2"></td>
        </tr>
        <tr>
          <td [attr.colspan]="staffs.length + 2">
            <h2>Bonuses </h2>
          </td>
        </tr>
        <tr>
          <td>Working Hours </td>
          <td>- - -</td>
          @for (staff of staffs; track staff) {
            <td>{{getByStaff(staff.name, 'E') / 60}} hrs</td>
          }
        </tr>
        <tr>
          <td>Recommended by </td>
          <td>{{report?.recommandded_by_total}}</td>
          @for (staff of staffs; track staff) {
            <td>{{getByStaff(staff.name, 'D')}}</td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>